import { render, staticRenderFns } from "./userViewModelIfram.vue?vue&type=template&id=b10adae0&scoped=true"
import script from "./userViewModelIfram.vue?vue&type=script&lang=js"
export * from "./userViewModelIfram.vue?vue&type=script&lang=js"
import style0 from "./userViewModelIfram.vue?vue&type=style&index=0&id=b10adae0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10adae0",
  null
  
)

export default component.exports